export default __webpack_public_path__ + "static/prob3-c08d95783f9cf7c844bbd7a9a2f859fb.png";